module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D09-clean-2924f2c5b97e435873b4f2739be5f831.png";